module.exports = __webpack_public_path__ + "img/Ahex_predel.3a373b5f.png";